import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export const EMPTY_HOLD = {
  hold_start_date: "",
  hold_expected_return: "",
  hold_instructions: "",
};

// Fields mirroring the paper "Physician Service Hold Order" form.
// Reason for hold is intentionally NOT collected — the form leaves it blank for the facility.
export function ServiceHoldFields({ value, onChange, idPrefix = "hold" }) {
  const v = { ...EMPTY_HOLD, ...(value || {}) };
  const set = (patch) => onChange({ ...v, ...patch });
  return (
    <div className="space-y-3 p-4 bg-amber-50 rounded-lg" data-testid={`${idPrefix}-fields`}>
      <h4 className="text-sm font-medium text-amber-800">Service Hold Order Details</h4>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-start`}>Hold Start Date</Label>
          <Input
            id={`${idPrefix}-start`}
            type="date"
            value={v.hold_start_date}
            onChange={(e) => set({ hold_start_date: e.target.value })}
            data-testid={`${idPrefix}-start`}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={`${idPrefix}-return`}>Expected Return Date</Label>
          <Input
            id={`${idPrefix}-return`}
            type="date"
            value={v.hold_expected_return}
            onChange={(e) => set({ hold_expected_return: e.target.value })}
            data-testid={`${idPrefix}-return`}
          />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${idPrefix}-instructions`}>Additional Physician Instructions / Follow-Up</Label>
        <Textarea
          id={`${idPrefix}-instructions`}
          value={v.hold_instructions}
          onChange={(e) => set({ hold_instructions: e.target.value })}
          placeholder="Optional — resume criteria, follow-up appointments..."
          rows={2}
          data-testid={`${idPrefix}-instructions`}
        />
      </div>
      <p className="text-xs text-amber-700" data-testid={`${idPrefix}-reason-note`}>
        "Reason for Hold" is left blank on the printed form for the physician / facility to complete.
      </p>
    </div>
  );
}
